// extracted by mini-css-extract-plugin
module.exports = {"bottomPopup":"bottomPopup__QXMD","header":"header__noqG","closePart":"closePart__KrT9","popup-content":"popup-content__W4wj"};
    if(module.hot) {
      // 1724307571249
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  